<template>
  <b-modal
    :hide-footer="true"
    :title="`Registro de Atividade ID #${item.id}`"
    centered
    id="modal-detalhes-auditoria"
  >
    <div class="row col m-0 p-0">
      <table class="table mb-3 table-striped table-hover table-sm border">
        <thead>
          <tr class="table-active">
            <td class="col font-weight-bold" colspan="2">Dados Novos</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-if="
              item.event == 'Importação de Beneficiários BF' ||
              item.event == 'Importação de Beneficiários BPC'
            "
          >
            <td>
              <p class="p-3" v-html="item.new_values"></p>
            </td>
          </tr>
          <tr v-else v-for="(value, name) in item.new_values" :key="name">
            <td>{{ name }}</td>
            <td>
              <strong v-html="value"></strong>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        class="table mb-3 table-striped table-hover table-sm border"
        v-if="item.old_values"
      >
        <thead>
          <tr class="table-active">
            <td class="col font-weight-bold" colspan="2">Dados Antigos</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(value, name) in item.old_values" :key="name">
            <td>{{ name }}</td>
            <td>
              <strong>{{ value }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 class="font-weight-bold">Detalhes</h5>
      <ul class="pl-4 col-12">
        <li>
          Usuário <strong>{{ item.user_id }}</strong>
        </li>
        <li>
          Model <strong>{{ item.auditable_type }}</strong>
        </li>
        <li>
          URL <strong>{{ item.url }}</strong>
        </li>
        <li>
          IP <strong>{{ item.ip_address }}</strong>
        </li>
        <li>
          Navegador <strong>{{ item.user_agent }}</strong>
        </li>
      </ul>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: ["item"],
};
</script>
